import { render, staticRenderFns } from "./mProductCard4.vue?vue&type=template&id=c0966438&scoped=true"
import script from "./mProductCard4.vue?vue&type=script&lang=js"
export * from "./mProductCard4.vue?vue&type=script&lang=js"
import style0 from "./mProductCard4.vue?vue&type=style&index=0&id=c0966438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0966438",
  null
  
)

export default component.exports